import {
  Avatar,
  Box,
  Checkbox,
  Typography,
  CircularProgress,
  Pagination,
  Stack,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import { ContentCopy, Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layout";

import AppTable from "../Dashboard/Table";
import { useQuery } from "@tanstack/react-query";
import { getTransactions } from "services/transaction";
import { useState } from "react";
import toast from "react-hot-toast";

const Transactions = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { data: transactionData, isLoading } = useQuery({
    queryKey: ["transactions", page, limit],
    queryFn: () => getTransactions(page, limit),
  });

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPage(value);
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
  };

  const header = [
    // {
    //   label: "Name",
    //   key: "name",
    // },
    {
      label: "Payment Reference",
      key: "paymentReference",
    },
    {
      label: "Transaction ID",
      key: "transactionId",
    },
    {
      label: "Amount",
      key: "amount",
    },
    {
      label: "Payment Method",
      key: "method",
    },
    {
      label: "Date",
      key: "date",
    },
    {
      label: "Status",
      key: "status",
    },
  ];

  const transactions = transactionData?.data?.transactions || [];

  const data = transactions.map((item: any) => ({
    // name: (
    //   <Box display="flex" alignItems="center">
    //     {/* <Box display="flex">
    //       <Checkbox />
    //       <Avatar src={item?.user?.profilePicture} alt={item?.user?.firstName}>
    //         {item?.user?.firstName?.charAt(0)}
    //       </Avatar>
    //     </Box> */}
    //     {/* <Box sx={{ fontSize: "12px !important", ml: 1 }}>
    //       <Typography sx={{ fontSize: "12px !important" }}>
    //         {item?.user?.firstName} {item?.user?.lastName}
    //       </Typography>
    //       <Typography sx={{ fontSize: "12px !important" }}>
    //         {item?.user?.email}
    //       </Typography>
    //     </Box> */}
    //   </Box>
    // ),
    paymentReference: item?.paymentReference || "N/A",
    transactionId: (
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontSize="12px">{item?.transaction_id || "N/A"}</Typography>
        {item?.transaction_id && (
          <Tooltip title="Copy Transaction ID">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.transaction_id);
              }}
            >
              <ContentCopy sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
    amount: `NGN ${item?.amount?.toLocaleString() || "0"}`,
    method: item?.payment_method || "Card Payment",
    date: item?.date ? new Date(item.date).toLocaleString() : "N/A",
    status: item?.status || "pending",
  }));

  if (isLoading) {
    return (
      <DashboardLayout nextSideBar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout nextSideBar>
      <Box sx={{ width: "100%" }}>
        <Box
          mb="24px"
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Typography
            color="#101828"
            fontSize="24px"
            fontWeight={600}
            mb={{ xs: 1, sm: 0 }}
          >
            Transactions
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate("/dashboard/transactions/create")}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              bgcolor: "#101828",
              "&:hover": { bgcolor: "#344054" },
            }}
          >
            Create Transaction
          </Button>
        </Box>
        {/* <TableSearch /> */}
        <Box>
          <AppTable headers={header} data={data} />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Pagination
              count={transactionData?.data?.pagination?.totalPages || 0}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Transactions;
